(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5684],{

/***/ 19434:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/billing/profiles",
      function () {
        return __webpack_require__(91381);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 58349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ billing_profiles; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(32016);
// EXTERNAL MODULE: ./node_modules/@styled-system/theme-get/dist/index.esm.js
var dist_index_esm = __webpack_require__(50056);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(15313);
// EXTERNAL MODULE: ./src/redux/reselect/billing.js
var billing = __webpack_require__(3411);
// EXTERNAL MODULE: ./src/theme/content-loader/index.js
var content_loader = __webpack_require__(52005);
// EXTERNAL MODULE: ./src/theme/billing-profile-card/index.js
var billing_profile_card = __webpack_require__(91940);
// EXTERNAL MODULE: ./src/theme/text/index.js
var theme_text = __webpack_require__(5799);
// EXTERNAL MODULE: ./src/theme/buttons/btn-link.js
var btn_link = __webpack_require__(25733);
// EXTERNAL MODULE: ./src/theme/icons/plus.js
var plus = __webpack_require__(26398);
// EXTERNAL MODULE: ./src/theme/buttons/btn.js
var btn = __webpack_require__(84146);
// EXTERNAL MODULE: ./src/theme/icons/close.js
var icons_close = __webpack_require__(5842);
;// CONCATENATED MODULE: ./src/theme/modal/confirm.js



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  body {\n    overflow-y: hidden;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  display: ",
        ";\n  justify-content: center;\n  align-items: center;\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: rgba(6, 119, 134, 0.6);\n  z-index: 999;\n\n  & > div {\n    ::-webkit-scrollbar {\n      display: none; /* Chrome Safari */\n    }\n\n    scrollbar-width: none; /* Firefox */\n    -ms-overflow-style: none; /* IE 10+ */\n    overflow-y: scroll;\n    overflow-x: hidden;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n\n  border-radius: 12px;\n  overflow: hidden;\n  padding: ",
        "px ",
        "px;\n\n  & > .head {\n    background: ",
        ";\n\n    & > .wrap-close {\n      width: 100%;\n      display: flex;\n      flex-direction: row;\n      justify-content: flex-end;\n    }\n\n    & > .wrap-title {\n      width: 100%;\n      display: flex;\n      flex-direction: row;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n\n  & > .body {\n    display: flex;\n    flex-direction: row;\n    padding: ",
        "px ",
        "px ",
        "px;\n  }\n\n  & > .footer {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    padding: 0 ",
        "px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var GlobalStyle = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(_templateObject());
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c5dd75cf-0"
})(_templateObject1(), function(param) {
    var isVisible = param.isVisible;
    return isVisible ? "flex" : "none";
});
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c5dd75cf-1"
})(_templateObject2(), index_esm/* color */.$_, index_esm/* layout */.bK, (0,dist_index_esm/* themeGet */.R)("space.s"), (0,dist_index_esm/* themeGet */.R)("space.s"), (0,dist_index_esm/* themeGet */.R)("colors.white"), (0,dist_index_esm/* themeGet */.R)("space.s"), (0,dist_index_esm/* themeGet */.R)("space.l"), (0,dist_index_esm/* themeGet */.R)("space.l"), (0,dist_index_esm/* themeGet */.R)("space.s"));
function ModalConfirm(param) {
    var contentStyle = param.contentStyle, width = param.width, style = param.style, isVisible = param.isVisible, title = param.title, message = param.message, onClickCancel = param.onClickCancel, onClickOk = param.onClickOk, okLabel = param.okLabel;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
        isVisible: isVisible,
        children: [
            isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyle, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    width: width || "420px",
                    bg: "white"
                }, contentStyle), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "head",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "wrap-close",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(btn_link/* default */.Z, {
                                        style: {
                                            height: 34,
                                            width: 34,
                                            minWidth: 34
                                        },
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_close/* default */.Z, {}),
                                        onClick: onClickCancel,
                                        title: "Close"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "wrap-title",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                        fontSize: "h2",
                                        lineHeight: "h2",
                                        fontWeight: "bold",
                                        color: "grey_600",
                                        children: title
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "body",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                fontSize: "display",
                                lineHeight: "display",
                                fontWeight: "medium",
                                color: "grey_400",
                                textAlign: "center",
                                children: message
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "footer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(btn/* default */.Z, {
                                onClick: onClickOk,
                                type: "button",
                                label: okLabel,
                                style: {
                                    width: "100%",
                                    paddingLeft: 8,
                                    paddingRight: 8
                                }
                            })
                        })
                    ]
                }))
            })
        ]
    }));
}
/* harmony default export */ var modal_confirm = (ModalConfirm);

// EXTERNAL MODULE: ./src/translations/index.js + 4 modules
var translations = __webpack_require__(99408);
;// CONCATENATED MODULE: ./src/components/billing/profiles/billing-profiles.js
/* eslint-disable no-nested-ternary */ 


function billing_profiles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 2100px;\n"
    ]);
    billing_profiles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function billing_profiles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n\n  ",
        "\n"
    ]);
    billing_profiles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function billing_profiles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  margin: ",
        "px 0;\n  padding: ",
        "px;\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 12px;\n  overflow: auto;\n\n  ",
        "\n"
    ]);
    billing_profiles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 220px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}















var Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c437734b-0"
})(billing_profiles_templateObject());
var Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c437734b-1"
})(billing_profiles_templateObject1(), index_esm/* flexbox */.GQ);
var CardsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c437734b-2"
})(billing_profiles_templateObject2(), (0,dist_index_esm/* themeGet */.R)("space.m"), (0,dist_index_esm/* themeGet */.R)("space.s"), (0,dist_index_esm/* themeGet */.R)("colors.primary_100"), (0,dist_index_esm/* themeGet */.R)("colors.primary_200"), index_esm/* layout */.bK);
var WrapEmpty = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c437734b-3"
})(_templateObject3());
function BillingProfiles(param) {
    var summaryVariant = param.summaryVariant, ids = param.ids;
    var push = (0,router.useRouter)().push;
    var ref = (0,react.useState)(false), modalNewProfileVisible = ref[0], setModalNewProfileVisible = ref[1];
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    var isProfilesWaiting = (0,es/* useSelector */.v9)(function(state) {
        return state.billing;
    }).isProfilesWaiting;
    var billingProfiles = (0,es/* useSelector */.v9)(billing/* selectBillingProfiles */.pV);
    var handleNewProfile = (0,react.useCallback)(function() {
        if (billingProfiles.total === 0) {
            return push("/billing/profile");
        }
        return setModalNewProfileVisible(true);
    }, [
        push,
        billingProfiles.total
    ]);
    var handleNewProfileCancel = (0,react.useCallback)(function() {
        setModalNewProfileVisible(false);
    }, []);
    var handleNewProfileOk = (0,react.useCallback)(function() {
        setModalNewProfileVisible(false);
        push("/billing/profile");
    }, [
        push
    ]);
    var filteredBillingProfiles = (0,react.useMemo)(function() {
        if (!summaryVariant) return billingProfiles;
        var profiles = billingProfiles.profiles;
        var filtered = profiles.filter(function(profile) {
            return Array.isArray(ids) && ids.includes(profile.id);
        });
        return {
            total: filtered.length,
            totalDraft: filtered.filter(function(profile) {
                return profile.isDraft;
            }).length,
            profiles: filtered
        };
    }, [
        ids,
        billingProfiles,
        summaryVariant
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                fontSize: "h3",
                                lineHeight: "h3",
                                fontWeight: "bold",
                                color: "grey_600",
                                children: summaryVariant ? translations/* default */.Z[languageCode]["Associated profiles"] : translations/* default */.Z[languageCode]["Billing Profiles"]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                pl: "xxs",
                                fontSize: "h3",
                                lineHeight: "h3",
                                fontWeight: "bold",
                                color: "primary_400",
                                children: filteredBillingProfiles.total
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                pl: "xxs",
                                fontSize: "display",
                                lineHeight: "display",
                                fontWeight: "medium",
                                color: "grey_400",
                                children: "(".concat(filteredBillingProfiles.totalDraft, " ").concat(translations/* default */.Z[languageCode].Draft, ")")
                            })
                        ]
                    }),
                    !summaryVariant && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(btn_link/* default */.Z, {
                            style: {
                                height: 38
                            },
                            label: translations/* default */.Z[languageCode]["Create new"],
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(plus/* default */.Z, {}),
                            onClick: handleNewProfile
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsContainer, {
                minHeight: "220px",
                children: isProfilesWaiting ? /*#__PURE__*/ (0,jsx_runtime.jsx)(content_loader/* default */.Z, {
                    width: 808,
                    height: 220,
                    lines: [
                        {
                            x: 0,
                            y: 0,
                            rx: 5,
                            ry: 5,
                            width: 400,
                            height: 220
                        },
                        {
                            x: 408,
                            y: 0,
                            rx: 5,
                            ry: 5,
                            width: 400,
                            height: 220
                        }, 
                    ]
                }) : filteredBillingProfiles.profiles.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapEmpty, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                        pl: "xxs",
                        fontSize: "pSmall",
                        lineHeight: "pSmall",
                        fontWeight: "normal",
                        color: "primary_600",
                        children: summaryVariant ? translations/* default */.Z[languageCode]["You don't have a “Billing Profile” associated"] : translations/* default */.Z[languageCode]["You don't have a “Billing Profile” yet"]
                    })
                }) : filteredBillingProfiles.profiles.map(function(profile) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(billing_profile_card/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        style: {
                            mr: "xs",
                            maxWidth: "400px",
                            border: profile.isDefault ? "3px solid" : "1px solid",
                            borderColor: profile.isDefault ? "primary_400" : "primary_200"
                        }
                    }, profile), {
                        subTitle: translations/* default */.Z[languageCode][profile.billingModeCode],
                        languageCode: languageCode,
                        extraInfo: true
                    }), profile.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_confirm, {
                isVisible: modalNewProfileVisible,
                title: translations/* default */.Z[languageCode]["You already have a billing profile"],
                message: translations/* default */.Z[languageCode]["We do not recommend having multiple. Please always use your default profile unless strictly necessary"],
                onClickCancel: handleNewProfileCancel,
                onClickOk: handleNewProfileOk,
                okLabel: translations/* default */.Z[languageCode]["Create another profile"]
            })
        ]
    });
}
/* harmony default export */ var billing_profiles = (BillingProfiles);


/***/ }),

/***/ 73097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15313);
/* harmony import */ var theme_sub_menu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66084);
/* harmony import */ var translations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99408);





function TopNav(param) {
    var _activeKey = param.activeKey, activeKey = _activeKey === void 0 ? "panoramic" : _activeKey;
    var languageCode = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.config;
    }).languageCode;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(theme_sub_menu__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        activeKey: activeKey,
        languageCode: languageCode,
        options: [
            {
                key: "panoramic",
                title: translations__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[languageCode].panoramic,
                href: "/billing"
            },
            {
                key: "profiles",
                title: translations__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[languageCode].profiles,
                href: "/billing/profiles"
            },
            {
                key: "documents",
                title: translations__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[languageCode].documents,
                href: "/billing/documents"
            },
            {
                key: "reports",
                title: translations__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[languageCode].reports,
                href: "/billing/reports"
            }, 
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (TopNav);


/***/ }),

/***/ 91381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_billing_profiles; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(32016);
// EXTERNAL MODULE: ./node_modules/@styled-system/theme-get/dist/index.esm.js
var dist_index_esm = __webpack_require__(50056);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(15313);
// EXTERNAL MODULE: ./src/components/auth-switch/index.js + 15 modules
var auth_switch = __webpack_require__(17343);
// EXTERNAL MODULE: ./src/components/warning-notification/index.js + 1 modules
var warning_notification = __webpack_require__(42805);
// EXTERNAL MODULE: ./src/redux/action/billing.js
var billing = __webpack_require__(52947);
// EXTERNAL MODULE: ./src/redux/reselect/profile.js
var profile = __webpack_require__(95293);
// EXTERNAL MODULE: ./src/components/billing/profiles/billing-profiles.js + 1 modules
var billing_profiles = __webpack_require__(58349);
// EXTERNAL MODULE: ./src/components/billing/profiles/payment-accounts.js
var payment_accounts = __webpack_require__(15201);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/redux/action/taxInterviews.js
var taxInterviews = __webpack_require__(16717);
// EXTERNAL MODULE: ./src/redux/reselect/taxInterviews.js
var reselect_taxInterviews = __webpack_require__(29942);
// EXTERNAL MODULE: ./src/theme/content-loader/index.js
var content_loader = __webpack_require__(52005);
// EXTERNAL MODULE: ./node_modules/react-circle-flags/dist/index.modern.js
var index_modern = __webpack_require__(9765);
// EXTERNAL MODULE: ./src/theme/status-label/index.js + 2 modules
var status_label = __webpack_require__(82333);
// EXTERNAL MODULE: ./src/theme/text/index.js
var theme_text = __webpack_require__(5799);
;// CONCATENATED MODULE: ./src/theme/tax-interview-card/index.js



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  width: 100%;\n  min-width: 390px;\n  min-height: 148px;\n  box-sizing: border-box;\n  border-radius: 8px;\n  padding: 16px 16px 16px 32px;\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  user-select: none;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 22px;\n  height: 22px;\n  margin-left: 8px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}








var Wrapper = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-c9781213-0"
})(_templateObject(), index_esm/* space */.Dh, index_esm/* border */.Cg, index_esm/* color */.$_, index_esm/* layout */.bK);
var Flex = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c9781213-1"
})(_templateObject1(), index_esm/* flexbox */.GQ, index_esm/* space */.Dh, index_esm/* position */.FK);
var StyledText = (0,styled_components_browser_esm/* default */.ZP)(theme_text/* default */.Z).withConfig({
    componentId: "sc-c9781213-2"
})(_templateObject2());
var StyledCircleFlag = (0,styled_components_browser_esm/* default */.ZP)(index_modern/* CircleFlag */.V).withConfig({
    componentId: "sc-c9781213-3"
})(_templateObject3());
function TaxInterviewCard(param) {
    var id = param.id, style = param.style, label = param.label, year = param.year, onClick = param.onClick, isDraft = param.isDraft, isDefault = param.isDefault, countryCode = param.countryCode, languageCode = param.languageCode;
    var push = (0,router.useRouter)().push;
    var handleClick = (0,react.useCallback)(function() {
        if (onClick) return onClick(id);
        return push({
            pathname: "/billing/summary-tax-interview",
            query: {
                id: id
            }
        });
    }, [
        push,
        onClick,
        id
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        bg: "white"
    }, style), {
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                position: "relative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                    flexDirection: "row",
                    alignItems: "center",
                    children: [
                        !isDraft && /*#__PURE__*/ (0,jsx_runtime.jsx)(status_label/* default */.Z, {
                            style: {
                                p: 0
                            },
                            languageCode: languageCode,
                            status: "COMPLETE"
                        }),
                        !!isDraft && /*#__PURE__*/ (0,jsx_runtime.jsx)(status_label/* default */.Z, {
                            style: {
                                p: 0
                            },
                            languageCode: languageCode,
                            status: "DRAFT"
                        }),
                        isDefault && /*#__PURE__*/ (0,jsx_runtime.jsx)(status_label/* default */.Z, {
                            style: {
                                margin: "0 0 0 10px"
                            },
                            languageCode: languageCode,
                            status: "DEFAULT"
                        }),
                        !!countryCode && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCircleFlag, {
                            countryCode: countryCode.toLowerCase()
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                mt: "s",
                fontSize: "h3",
                lineHeight: "h3",
                fontWeight: "bold",
                color: "grey_600",
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                mt: "xs",
                fontSize: "display",
                lineHeight: "display",
                fontWeight: "medium",
                color: "grey_400",
                children: year
            })
        ]
    }));
}
/* harmony default export */ var tax_interview_card = (TaxInterviewCard);

// EXTERNAL MODULE: ./src/theme/buttons/btn-link.js
var btn_link = __webpack_require__(25733);
// EXTERNAL MODULE: ./src/theme/icons/plus.js
var plus = __webpack_require__(26398);
// EXTERNAL MODULE: ./src/translations/index.js + 4 modules
var translations = __webpack_require__(99408);
;// CONCATENATED MODULE: ./src/components/billing/profiles/tax-interviews.js
/* eslint-disable no-nested-ternary */ 


function tax_interviews_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 2100px;\n"
    ]);
    tax_interviews_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function tax_interviews_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n\n  ",
        "\n"
    ]);
    tax_interviews_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function tax_interviews_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  margin: ",
        "px 0;\n  padding: ",
        "px;\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 12px;\n  overflow: auto;\n\n  ",
        "\n"
    ]);
    tax_interviews_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function tax_interviews_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 220px;\n"
    ]);
    tax_interviews_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}















var Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e066e76c-0"
})(tax_interviews_templateObject());
var Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e066e76c-1"
})(tax_interviews_templateObject1(), index_esm/* flexbox */.GQ);
var CardsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e066e76c-2"
})(tax_interviews_templateObject2(), (0,dist_index_esm/* themeGet */.R)("space.m"), (0,dist_index_esm/* themeGet */.R)("space.s"), (0,dist_index_esm/* themeGet */.R)("colors.primary_100"), (0,dist_index_esm/* themeGet */.R)("colors.primary_200"), index_esm/* layout */.bK);
var WrapEmpty = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e066e76c-3"
})(tax_interviews_templateObject3());
function TaxInterviews() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var push = (0,router.useRouter)().push;
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    var isWaiting = (0,es/* useSelector */.v9)(function(state) {
        return state.billing;
    }).isWaiting;
    var payload = (0,es/* useSelector */.v9)(reselect_taxInterviews/* default */.ZP);
    (0,react.useEffect)(function() {
        dispatch((0,taxInterviews/* getTaxInterviewsRequest */.tu)({
            page: 0,
            pageSize: 10
        }));
    }, [
        dispatch
    ]);
    var handleOnClickNew = (0,react.useCallback)(function() {
        return push("/billing/tax-interview");
    }, [
        push
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                fontSize: "h3",
                                lineHeight: "h3",
                                fontWeight: "bold",
                                color: "grey_600",
                                children: translations/* default */.Z[languageCode]["Tax Interviews"]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                pl: "xxs",
                                fontSize: "h3",
                                lineHeight: "h3",
                                fontWeight: "bold",
                                color: "primary_400",
                                children: payload.totalCount
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(btn_link/* default */.Z, {
                            label: translations/* default */.Z[languageCode]["Create new"],
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(plus/* default */.Z, {}),
                            onClick: handleOnClickNew
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsContainer, {
                minHeight: "148px",
                children: isWaiting ? /*#__PURE__*/ (0,jsx_runtime.jsx)(content_loader/* default */.Z, {
                    width: 808,
                    height: 148,
                    lines: [
                        {
                            x: 0,
                            y: 0,
                            rx: 5,
                            ry: 5,
                            width: 400,
                            height: 148
                        },
                        {
                            x: 408,
                            y: 0,
                            rx: 5,
                            ry: 5,
                            width: 400,
                            height: 148
                        }, 
                    ]
                }) : payload.totalCount === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapEmpty, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                        pl: "xxs",
                        fontSize: "pSmall",
                        lineHeight: "pSmall",
                        fontWeight: "normal",
                        color: "primary_600",
                        children: translations/* default */.Z[languageCode]["You don't have a “Tax Interview” yet"]
                    })
                }) : payload.data.map(function(taxInterview) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(tax_interview_card, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        style: {
                            mr: "xs",
                            maxWidth: "400px",
                            border: "1px solid",
                            borderColor: "primary_200"
                        }
                    }, taxInterview), {
                        languageCode: languageCode
                    }), taxInterview.id);
                })
            })
        ]
    });
}
/* harmony default export */ var tax_interviews = (TaxInterviews);

;// CONCATENATED MODULE: ./src/components/billing/profiles/index.js
/* eslint-disable no-nested-ternary */ 
function profiles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n\n  & > div {\n    width: 100%;\n    max-width: 2100px;\n  }\n"
    ]);
    profiles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var profiles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ea0d5cbf-0"
})(profiles_templateObject(), index_esm/* space */.Dh);
function Profiles() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(profile/* default */.Z), company = ref.payload.company;
    (0,react.useEffect)(function() {
        dispatch((0,billing/* getBillingProfilesRequest */.KQ)());
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(profiles_Wrapper, {
        px: "l",
        py: "xs",
        my: "xs",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(billing_profiles/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(payment_accounts/* default */.Z, {
                    edit: false,
                    company: company === null || company === void 0 ? void 0 : company.code
                }),
                !!company && company.code === "SL_US" && /*#__PURE__*/ (0,jsx_runtime.jsx)(tax_interviews, {})
            ]
        })
    });
}
/* harmony default export */ var profiles = (Profiles);

// EXTERNAL MODULE: ./src/components/billing/top-nav.js
var top_nav = __webpack_require__(73097);
// EXTERNAL MODULE: ./src/theme/header/index.js + 1 modules
var header = __webpack_require__(28116);
// EXTERNAL MODULE: ./src/theme/layouts/body.js
var body = __webpack_require__(89129);
// EXTERNAL MODULE: ./src/components/top-bar/index.js
var top_bar = __webpack_require__(32095);
;// CONCATENATED MODULE: ./src/pages/billing/profiles.js

function billing_profiles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  min-width: 1024px;\n"
    ]);
    billing_profiles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function profiles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        "px ",
        "px 0;\n"
    ]);
    profiles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}















var billing_profiles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3460e2e0-0"
})(billing_profiles_templateObject(), index_esm/* space */.Dh);
var StyledWarningNotification = (0,styled_components_browser_esm/* default */.ZP)(warning_notification/* default */.Z).withConfig({
    componentId: "sc-3460e2e0-1"
})(profiles_templateObject1(), (0,dist_index_esm/* themeGet */.R)("space.l"), (0,dist_index_esm/* themeGet */.R)("space.l"));
function BillingProfilesPage() {
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(auth_switch/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(top_bar/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(billing_profiles_Wrapper, {
                pb: "xxl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(body/* default */.Z, {
                        bg: "primary_50",
                        height: "100%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* default */.Z, {
                        bg: "white",
                        title: translations/* default */.Z[languageCode]["Billing Profiles"],
                        style: {
                            bg: "white",
                            borderWidth: "0",
                            borderBottomWidth: "1px",
                            borderColor: "primary_200",
                            borderStyle: "solid"
                        },
                        componentLeft: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                            ml: "l",
                            fontSize: "h2",
                            lineHeight: "h2",
                            fontWeight: "bold",
                            color: "grey_600",
                            textAlign: "left",
                            children: translations/* default */.Z[languageCode].billing
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(top_nav/* default */.Z, {
                        activeKey: "profiles"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWarningNotification, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(profiles, {})
                ]
            })
        ]
    });
}
/* harmony default export */ var pages_billing_profiles = (BillingProfilesPage);


/***/ }),

/***/ 29942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bl": function() { return /* binding */ selectTaxInterviewFormErrors; },
/* harmony export */   "Zo": function() { return /* binding */ selectWithholdingCode; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68697);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* eslint-disable camelcase */ 




var selectTaxInterviews = (0,reselect__WEBPACK_IMPORTED_MODULE_1__/* .createSelector */ .P1)(function(state) {
    return state.taxInterviews.payload;
}, function(payload) {
    var data = payload.data, meta = payload.meta;
    if (!data || !data.length) {
        return {
            pageNumber: 1,
            perPage: 10,
            totalPages: 0,
            totalCount: 0,
            data: []
        };
    }
    var current = meta.pageNumber.current, perPage = meta.perPage, totalPages = meta.totalPages, totalCount = meta.totalCount;
    return {
        pageNumber: current,
        perPage: perPage,
        totalPages: totalPages,
        totalCount: totalCount,
        data: data.map(function(param) {
            var id = param.id, attributes = param.attributes, downloadLink = param.links.downloadLink;
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                key: id,
                id: id
            }, attributes, attributes.formData), {
                bornOn: attributes.formData && attributes.formData.bornOn ? moment__WEBPACK_IMPORTED_MODULE_0___default()(attributes.formData.bornOn, "YYYY-MM-DD") : null,
                isDraft: !attributes.formDataValid,
                downloadLink: downloadLink
            });
        })
    };
});
var selectTaxInterviewFormErrors = (0,reselect__WEBPACK_IMPORTED_MODULE_1__/* .createSelector */ .P1)(function(state) {
    return state.taxInterviews.errors;
}, function(payload) {
    var errors = {};
    if (payload && payload.status === "CUSTOM-ERROR") {
        payload.data.errors.forEach(function(param) {
            var type = param.type, detail = param.detail;
            var field = type.split(":")[1];
            errors = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, errors), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, field, detail));
        });
    }
    return errors;
});
var selectWithholdingCode = (0,reselect__WEBPACK_IMPORTED_MODULE_1__/* .createSelector */ .P1)(function(state) {
    return state.taxInterviews.withholdingCode;
}, function(payload) {
    var data = payload.data;
    if (!data || !data.id) {
        return {
            name: "",
            code: ""
        };
    }
    return {
        name: data.attributes.name,
        code: data.attributes.code
    };
});
/* harmony default export */ __webpack_exports__["ZP"] = (selectTaxInterviews);



/***/ }),

/***/ 72846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14141);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32016);
/* harmony import */ var _styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50056);
/* harmony import */ var theme_text__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5799);
/* harmony import */ var theme_icons_alert__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88176);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n\n  & > span {\n    display: flex;\n    align-items: center;\n    color: ",
        ";\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-acd3e5bb-0"
})(_templateObject(), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.warning"), styled_system__WEBPACK_IMPORTED_MODULE_3__/* .space */ .Dh, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .color */ .$_);
function AlertMessage(param) {
    var message = param.message, style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, style), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_icons_alert__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_text__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                fontSize: "h4",
                lineHeight: "h4",
                fontWeight: "medium",
                color: "grey_600",
                ml: "xs",
                children: message
            })
        ]
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (AlertMessage);


/***/ }),

/***/ 84146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32016);
/* harmony import */ var _styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50056);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14141);
/* harmony import */ var theme_icons_loader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39024);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 56px;\n  min-width: 140px;\n  background: transparent;\n  outline: 0;\n\n  & > span {\n    background: ",
        ";\n    border-radius: 12px;\n\n    padding: 0 ",
        "px;\n\n    width: 100%;\n    height: 100%;\n\n    ",
        "\n    ",
        "\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    &:hover {\n      background: ",
        ";\n    }\n\n    &:focus {\n      background: ",
        ";\n    }\n  }\n\n  &:focus {\n    background: transparent;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: ",
        "px;\n  width: 18px;\n  height: 18px;\n  animation: ",
        " 2s linear infinite;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var rotate = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .keyframes */ .F4)(_templateObject());
var Button = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-6a93806c-0"
})(_templateObject1(), function(param) {
    var isFocused = param.isFocused;
    return isFocused ? (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.primary_600") : (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.primary_400");
}, (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("space.s"), styled_system__WEBPACK_IMPORTED_MODULE_3__/* .color */ .$_, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .typography */ .cp, (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.primary_500"), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.primary_600"), styled_system__WEBPACK_IMPORTED_MODULE_3__/* .space */ .Dh, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .layout */ .bK);
var WrapLoader = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6a93806c-1"
})(_templateObject2(), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("space.xs"), rotate);
function Btn(param) {
    var style = param.style, label = param.label, type = param.type, onClick = param.onClick, disabled = param.disabled, title = param.title, isWaiting = param.isWaiting;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Button, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        title: title || label,
        fontSize: "h4",
        lineHeight: "h4",
        fontWeight: "bold",
        color: "white",
        px: "l"
    }, style), {
        type: type,
        disabled: disabled || isWaiting,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
            children: [
                label,
                isWaiting && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WrapLoader, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_icons_loader__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        width: 18
                    })
                })
            ]
        })
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (Btn);


/***/ }),

/***/ 66084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14141);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32016);
/* harmony import */ var _styled_system_theme_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50056);
/* harmony import */ var theme_text__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5799);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  border-bottom: 1px solid ",
        ";\n\n  ",
        "\n\n  & > a {\n    text-decoration: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 8px;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 2px;\n  height: 34px; /* Altezza adeguata per stare tra i bottoni */\n  background-color: ",
        ";\n  margin: 0 8px; /* Spazio tra gli elementi */\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c093c216-0"
})(_templateObject(), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_5__/* .themeGet */ .R)("colors.primary_200"), styled_system__WEBPACK_IMPORTED_MODULE_4__/* .space */ .Dh);
var TabBtn = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-c093c216-1"
})(_templateObject1(), styled_system__WEBPACK_IMPORTED_MODULE_4__/* .color */ .$_, styled_system__WEBPACK_IMPORTED_MODULE_4__/* .space */ .Dh);
var HorizontalDivider = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c093c216-2"
})(_templateObject2(), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_5__/* .themeGet */ .R)("colors.primary_200"));
function SubMenu(param) {
    var activeKey = param.activeKey, options = param.options;
    var isConfirmed = options.length > 0 && options[1].key === "confirmed";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        py: "s",
        px: "l",
        children: options.map(function(option, index) {
            var isSecondWithOnClick = index === 1 && option.onClick;
            var nextOptionExists = index < options.length - 1;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                children: [
                    !option.onClick ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                        href: option.href,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                            className: "link",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TabBtn, {
                                type: "button",
                                py: "s",
                                px: "m",
                                bg: activeKey === option.key ? "primary_100" : "transparent",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_text__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    fontSize: "h3",
                                    lineHeight: "h3",
                                    fontWeight: "medium",
                                    color: activeKey === option.key ? "primary_500" : option.color ? option.color : "grey_400",
                                    textAlign: "center",
                                    children: option.title
                                })
                            })
                        })
                    }, option.key) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TabBtn, {
                        type: "button",
                        py: "s",
                        px: "m",
                        bg: activeKey === option.key ? "primary_100" : (option === null || option === void 0 ? void 0 : option.bgColor) ? option === null || option === void 0 ? void 0 : option.bgColor : "transparent",
                        onClick: option.onClick,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_text__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            fontSize: "h3",
                            lineHeight: "h3",
                            fontWeight: "medium",
                            color: activeKey === option.key ? "primary_500" : (option === null || option === void 0 ? void 0 : option.color) ? option === null || option === void 0 ? void 0 : option.color : "grey_400",
                            textAlign: "center",
                            children: option.title
                        })
                    }),
                    isSecondWithOnClick && nextOptionExists && isConfirmed && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HorizontalDivider, {})
                ]
            }, option.key);
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (SubMenu);


/***/ }),

/***/ 88357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w_": function() { return /* reexport */ GenIcon; }
});

// UNUSED EXPORTS: DefaultContext, IconBase, IconContext, IconsManifest

;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconsManifest.js
var IconsManifest = [
  {
    "id": "ci",
    "name": "Circum Icons",
    "projectUrl": "https://circumicons.com/",
    "license": "MPL-2.0 license",
    "licenseUrl": "https://github.com/Klarr-Agency/Circum-Icons/blob/main/LICENSE"
  },
  {
    "id": "fa",
    "name": "Font Awesome 5",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "fa6",
    "name": "Font Awesome 6",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "io",
    "name": "Ionicons 4",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "io5",
    "name": "Ionicons 5",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "md",
    "name": "Material Design icons",
    "projectUrl": "http://google.github.io/material-design-icons/",
    "license": "Apache License Version 2.0",
    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
  },
  {
    "id": "ti",
    "name": "Typicons",
    "projectUrl": "http://s-ings.com/typicons/",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
  },
  {
    "id": "go",
    "name": "Github Octicons icons",
    "projectUrl": "https://octicons.github.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
  },
  {
    "id": "fi",
    "name": "Feather",
    "projectUrl": "https://feathericons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
  },
  {
    "id": "lu",
    "name": "Lucide",
    "projectUrl": "https://lucide.dev/",
    "license": "ISC",
    "licenseUrl": "https://github.com/lucide-icons/lucide/blob/main/LICENSE"
  },
  {
    "id": "gi",
    "name": "Game Icons",
    "projectUrl": "https://game-icons.net/",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
  },
  {
    "id": "wi",
    "name": "Weather Icons",
    "projectUrl": "https://erikflowers.github.io/weather-icons/",
    "license": "SIL OFL 1.1",
    "licenseUrl": "http://scripts.sil.org/OFL"
  },
  {
    "id": "di",
    "name": "Devicons",
    "projectUrl": "https://vorillaz.github.io/devicons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ai",
    "name": "Ant Design Icons",
    "projectUrl": "https://github.com/ant-design/ant-design-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "bs",
    "name": "Bootstrap Icons",
    "projectUrl": "https://github.com/twbs/icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ri",
    "name": "Remix Icon",
    "projectUrl": "https://github.com/Remix-Design/RemixIcon",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "fc",
    "name": "Flat Color Icons",
    "projectUrl": "https://github.com/icons8/flat-color-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "gr",
    "name": "Grommet-Icons",
    "projectUrl": "https://github.com/grommet/grommet-icons",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "hi",
    "name": "Heroicons",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "hi2",
    "name": "Heroicons 2",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "si",
    "name": "Simple Icons",
    "projectUrl": "https://simpleicons.org/",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "id": "sl",
    "name": "Simple Line Icons",
    "projectUrl": "https://thesabbir.github.io/simple-line-icons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "im",
    "name": "IcoMoon Free",
    "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://github.com/Keyamoon/IcoMoon-Free/blob/master/License.txt"
  },
  {
    "id": "bi",
    "name": "BoxIcons",
    "projectUrl": "https://github.com/atisawd/boxicons",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://github.com/atisawd/boxicons/blob/master/LICENSE"
  },
  {
    "id": "cg",
    "name": "css.gg",
    "projectUrl": "https://github.com/astrit/css.gg",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "vsc",
    "name": "VS Code Icons",
    "projectUrl": "https://github.com/microsoft/vscode-codicons",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "tb",
    "name": "Tabler Icons",
    "projectUrl": "https://github.com/tabler/tabler-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "tfi",
    "name": "Themify Icons",
    "projectUrl": "https://github.com/lykmapipo/themify-icons",
    "license": "MIT",
    "licenseUrl": "https://github.com/thecreation/standard-icons/blob/master/modules/themify-icons/LICENSE"
  },
  {
    "id": "rx",
    "name": "Radix Icons",
    "projectUrl": "https://icons.radix-ui.com",
    "license": "MIT",
    "licenseUrl": "https://github.com/radix-ui/icons/blob/master/LICENSE"
  },
  {
    "id": "pi",
    "name": "Phosphor Icons",
    "projectUrl": "https://github.com/phosphor-icons/core",
    "license": "MIT",
    "licenseUrl": "https://github.com/phosphor-icons/core/blob/main/LICENSE"
  },
  {
    "id": "lia",
    "name": "Icons8 Line Awesome",
    "projectUrl": "https://icons8.com/line-awesome",
    "license": "MIT",
    "licenseUrl": "https://github.com/icons8/line-awesome/blob/master/LICENSE.md"
  }
]
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconContext.js

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = react.createContext && react.createContext(DefaultContext);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconBase.js
var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};


function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return react.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}
function GenIcon(data) {
  // eslint-disable-next-line react/display-name
  return function (props) {
    return react.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function (conf) {
    var attr = props.attr,
      size = props.size,
      title = props.title,
      svgProps = __rest(props, ["attr", "size", "title"]);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + " " : "") + props.className;
    return react.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && react.createElement("title", null, title), props.children);
  };
  return IconContext !== undefined ? react.createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/index.js




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3092,1664,8098,4762,6535,7343,3497,7234,7935,5201,9774,2888,179], function() { return __webpack_exec__(19434); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);